import { render, staticRenderFns } from "./BillingTopUpModal.vue?vue&type=template&id=6ad8206e&scoped=true&"
import script from "./BillingTopUpModal.vue?vue&type=script&lang=js&"
export * from "./BillingTopUpModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad8206e",
  null
  
)

export default component.exports